/* ==========================================================================
   DOLLZ theme.js — vanilla, dependency-free, loaded with `defer`.
   Modules: UI (drawers/modals/search), Cart, Product (variants/gallery), QuickView,
   Wishlist, Recent, Facets (AJAX filters), SmartSearch, Popup, Forms, Analytics hooks.
   ========================================================================== */
(function () {
  'use strict';

  var PD = window.PD = window.PD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var track = function (e, p) { if (PD.track) PD.track(e, p || {}); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };
  var parseHTML = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };

  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  PD.toast = toast;

  /* ---------------- Focus trap + scroll lock ---------------- */
  var openLayers = [];
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function openLayer(el, opener) {
    if (!el) return;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    el._opener = opener || document.activeElement;
    openLayers.push(el); lock(true);
    var f = $$(FOCUSABLE, el).filter(function (x) { return x.offsetParent !== null; })[0];
    setTimeout(function () { (f || el).focus && (f || el).focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    var isModal = el.classList.contains('modal') || el.classList.contains('search-ov');
    if (isModal) el.hidden = true;
    openLayers = openLayers.filter(function (x) { return x !== el; });
    if (!openLayers.length) lock(false);
    if (el._opener && el._opener.focus) el._opener.focus();
    if (el.id === 'NewsletterPopup') Popup.dismiss();
  }
  PD.openLayer = openLayer; PD.closeLayer = closeLayer;

  document.addEventListener('keydown', function (e) {
    var top = openLayers[openLayers.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { closeLayer(top); return; }
    if (e.key === 'Tab') {
      var f = $$(FOCUSABLE, top).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Global click delegation ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-open-drawer]'))) { e.preventDefault(); openLayer(document.getElementById(el.getAttribute('data-open-drawer')), el); return; }
    if ((el = t.closest('[data-close-drawer]'))) { e.preventDefault(); closeLayer(el.closest('.drawer')); return; }
    if ((el = t.closest('[data-open-cart]'))) { e.preventDefault(); openLayer($('#CartDrawer'), el); return; }
    if ((el = t.closest('[data-open-search]'))) { e.preventDefault(); Search.open(el); return; }
    if ((el = t.closest('[data-close-search]'))) { e.preventDefault(); closeLayer($('#SearchOverlay')); return; }
    if ((el = t.closest('.modal [data-close]'))) { e.preventDefault(); closeLayer(el.closest('.modal')); return; }
    if ((el = t.closest('[data-open-facets]'))) { e.preventDefault(); openLayer($('#FacetsDrawer'), el); return; }
    if ((el = t.closest('[data-close-facets]'))) { e.preventDefault(); closeLayer($('#FacetsDrawer')); return; }
    if ((el = t.closest('[data-quick-view]'))) { e.preventDefault(); QuickView.open(el.getAttribute('data-quick-view'), el); return; }
    if ((el = t.closest('[data-wish]'))) { e.preventDefault(); Wishlist.toggle(el.getAttribute('data-wish')); return; }
    if ((el = t.closest('[data-open-stylist]'))) { e.preventDefault(); Stylist.open(el); return; }
    if ((el = t.closest('[data-size-guide]'))) { e.preventDefault(); SizeGuide.open(el.getAttribute('href'), el); return; }
    if ((el = t.closest('[data-qty-change]'))) { e.preventDefault(); Cart.change(+el.getAttribute('data-qty-change'), +el.getAttribute('data-qty')); return; }
    if ((el = t.closest('[data-copy]'))) { copy(el.getAttribute('data-copy')); return; }
    if ((el = t.closest('[data-track]')) && el.tagName !== 'BUTTON') {
      track(el.getAttribute('data-track'), { location: el.getAttribute('data-track-location') || '', color: el.getAttribute('data-track-color') || undefined });
    }
  });

  function copy(text) {
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(function () { toast('Copied ' + text); });
  }

  /* ---------------- Header ---------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    $$('[data-mega]').forEach(function (item) {
      var link = item.querySelector('.nav__link');
      item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); } });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); var f = item.querySelector('.mega a'); if (f) f.focus(); }
      });
    });
  }

  /* ---------------- Announcement rotation ---------------- */
  $$('[data-announce]').forEach(function (bar) {
    var track_ = bar.querySelector('.announce__track');
    var items = $$('.announce__item', bar);
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, ms = (+bar.getAttribute('data-interval') || 5) * 1000;
    setInterval(function () {
      items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].removeAttribute('aria-hidden');
      track_.style.transform = 'translateX(' + (-100 * i) + '%)';
    }, ms);
  });

  /* ---------------- Reveal on scroll ---------------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(root) { $$('.reveal:not(.is-in)', root).forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); }); }
  PD.reveal = reveal;
  reveal();

  /* ---------------- Footer accordions: collapsed on mobile ---------------- */
  if (matchMedia('(max-width: 989px)').matches) $$('[data-footer-acc]').forEach(function (d) { d.open = false; });

  /* ---------------- Carousels (reviews) ---------------- */
  $$('[data-carousel]').forEach(function (track_) {
    var wrap = track_.parentElement;
    var step = function (dir) { track_.scrollBy({ left: dir * track_.clientWidth * 0.9, behavior: 'smooth' }); };
    var p = wrap.querySelector('[data-carousel-prev]'), n = wrap.querySelector('[data-carousel-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });

  /* ======================================================================
     CART
     ====================================================================== */
  var Cart = PD.cart = {
    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = n > 0 ? n : ''; c.setAttribute('data-count', n); });
    },
    renderDrawer: function (html) {
      if (!html) return;
      var doc = parseHTML(html);
      var fresh = doc.querySelector('#CartDrawer .drawer__panel');
      var cur = $('#CartDrawer .drawer__panel');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    },
    add: function (id, qty, btn) {
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      return fetch(PD.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }], sections: 'cart-drawer', sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        Cart.renderDrawer(res.sections && res.sections['cart-drawer']);
        var item = res.items && res.items[0];
        if (item) track('add_to_cart', { currency: 'USD', value: item.final_line_price / 100, items: [{ item_id: item.sku || item.variant_id, item_name: item.product_title, item_brand: item.vendor, item_variant: item.variant_title, price: item.final_price / 100, quantity: item.quantity }] });
        return fetch(PD.routes.cart + '.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        Cart.setCount(cart.item_count);
        var qv = $('#QuickView'); if (qv && !qv.hidden) closeLayer(qv);
        openLayer($('#CartDrawer'));
      }).catch(function (err) { toast(err.message || 'Could not add to bag'); })
        .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
    },
    change: function (line, qty) {
      return fetch(PD.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, qty), sections: 'cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (res) {
        Cart.renderDrawer(res.sections && res.sections['cart-drawer']);
        Cart.setCount(res.item_count);
      });
    }
  };
  document.addEventListener('change', function (e) {
    var q = e.target.closest('[data-qty-input]');
    if (q) Cart.change(+q.getAttribute('data-qty-input'), +q.value);
  });

  /* ======================================================================
     PRODUCT — variant picker, availability, gallery, lightbox
     ====================================================================== */
  function initProduct(root) {
    if (!root || root._pd) return; root._pd = true;
    var jsonEl = root.querySelector('[data-product-json]') || (!root.hasAttribute('data-quick') && document.querySelector('script[data-product-json]'));
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-btn]');
    var msg = root.querySelector('[data-variant-msg]');
    var avail = root.querySelector('[data-avail]');
    var isMain = !root.hasAttribute('data-quick');
    var sizeIdx = (data.sizeIndex || 0) - 1;
    var colorIdx = (data.colorIndex || 0) - 1;
    // Quick view JSON doesn't carry indexes — infer from inputs
    if (sizeIdx < 0 && root.querySelector('[data-size-grid] [data-option]')) sizeIdx = +root.querySelector('[data-size-grid] [data-option]').getAttribute('data-option') - 1;
    if (colorIdx < 0 && root.querySelector('.opt__colors [data-option]')) colorIdx = +root.querySelector('.opt__colors [data-option]').getAttribute('data-option') - 1;

    function selected() {
      var opts = [];
      $$('[data-option]', root).forEach(function (inp) {
        var pos = +inp.getAttribute('data-option') - 1;
        if (inp.tagName === 'SELECT') opts[pos] = inp.value;
        else if (inp.checked) opts[pos] = inp.value;
      });
      return opts;
    }
    function find(opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; }); })[0];
    }
    var LABEL = { in: 'In stock', order: 'Available to order', out: 'Sold out' };
    // Pre-order ship dates (main product page only): [data-ship-dates] maps "Color / Size" to an ISO date.
    var shipEl = root.querySelector('[data-ship]');
    var shipDates = {};
    var shipJson = root.querySelector('[data-ship-dates]');
    if (shipJson) { try { shipDates = JSON.parse(shipJson.textContent) || {}; } catch (e) { shipDates = {}; } }
    function shipFor(v) {
      if (!v || v.state !== 'order') return '';
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(shipDates[v.options.join(' / ')] || '');
      if (!m) return '';
      return new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }
    function update(fromUser) {
      var opts = selected();
      var v = find(opts);
      opts.forEach(function (val, i) { var l = root.querySelector('[data-option-label="' + (i + 1) + '"]'); if (l && val) l.textContent = val; });

      // Size grid states for the selected colour
      if (sizeIdx >= 0) {
        $$('[data-size-value]', root).forEach(function (lab) {
          var size = lab.getAttribute('data-size-value');
          var probe = opts.slice(); probe[sizeIdx] = size;
          var pv = find(probe);
          var st = pv ? pv.state : 'out';
          lab.classList.toggle('is-order', st === 'order');
          lab.classList.toggle('is-out', st === 'out');
          var note = lab.querySelector('[data-size-note]');
          if (note) note.textContent = st === 'in' ? 'In stock' : st === 'order' ? 'Order' : '';
        });
      }
      if (!v) {
        if (msg) msg.textContent = 'That combination isn’t available — try another size or colour.';
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = PD.strings.unavailable || 'Unavailable'; }
        if (shipEl) { shipEl.hidden = true; shipEl.textContent = ''; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (avail) {
        avail.textContent = LABEL[v.state];
        avail.className = 'pdp__avail ' + (v.state === 'in' ? 'avail--in' : v.state === 'order' ? 'avail--order' : 'avail--out');
      }
      if (msg) msg.textContent = v.state === 'in' ? 'In stock — in-stock styles can usually ship today or next day. Call to confirm it’s in the boutique for a try-on.' : v.state === 'order' ? 'Not in stock in this size — we’ll order it for you. Ask a stylist for timing.' : 'This size and colour is sold out. Ask a stylist about alternatives.';
      var priceEl = root.querySelector('[data-price]');
      if (priceEl) {
        var html = '<span>' + v.priceFmt + '</span>';
        if (v.compare > v.price) html += '<s class="price__was">' + v.compareFmt + '</s><span class="price__off">' + Math.round((v.compare - v.price) * 100 / v.compare) + '% OFF</span>';
        priceEl.innerHTML = html; priceEl.classList.toggle('price--sale', v.compare > v.price);
      }
      var sku = root.querySelector('[data-sku]'); if (sku && v.sku && !data.style) sku.textContent = v.sku;
      if (addBtn) {
        addBtn.disabled = v.state === 'out';
        addBtn.innerHTML = v.state === 'out' ? (PD.strings.soldOut || 'Sold out') : (isMain ? 'Add to bag — ' + v.priceFmt : 'Add to bag');
      }
      var shipBy = shipFor(v);
      if (shipEl) { shipEl.hidden = !shipBy; shipEl.textContent = shipBy ? 'Pre-order — ships by ' + shipBy : ''; }
      if (shipBy) {
        if (avail) avail.textContent = 'Pre-order';
        if (addBtn) addBtn.innerHTML = isMain ? 'Pre-order now — ' + v.priceFmt : 'Pre-order now';
      }
      var sp = $('[data-sticky-price]'); if (sp && isMain) sp.textContent = v.priceFmt;
      if (isMain && fromUser) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      }
      // Stylist modal prefill
      $$('[data-open-stylist]', root).forEach(function (b) {
        b.setAttribute('data-size', sizeIdx >= 0 ? (opts[sizeIdx] || '') : '');
        b.setAttribute('data-color', colorIdx >= 0 ? (opts[colorIdx] || '') : '');
      });
      // Gallery: jump to variant image or first image whose alt matches the colour
      if (fromUser && colorIdx >= 0) Gallery.goToColor(root, opts[colorIdx], v.media);
    }
    root.addEventListener('change', function (e) { if (e.target.hasAttribute('data-option')) update(true); });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput.value) return;
      Cart.add(+idInput.value, 1, addBtn);
    });
    update(false);

    if (isMain) {
      Recent.push(data.handle);
      track('view_item', { currency: 'USD', value: data.price, items: [{ item_id: data.style, item_name: data.title, item_brand: data.vendor }] });
      // Sticky add-to-bag
      var sticky = $('[data-sticky-atc]');
      var ctas = root.querySelector('.pdp__ctas');
      if (sticky && ctas && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }).observe(ctas);
        var sa = sticky.querySelector('[data-sticky-add]');
        if (sa) sa.addEventListener('click', function () {
          var v = find(selected());
          if (sizeIdx >= 0 && !$$('[data-size-grid] input', root).some(function (i) { return i.checked; })) { ctas.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (v && v.state !== 'out') Cart.add(v.id, 1, sa); else ctas.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      Gallery.init(root);
    }
  }
  PD.initProduct = initProduct;

  var Gallery = {
    init: function (root) {
      var track_ = root.querySelector('[data-gallery-track]');
      var dots = $$('[data-gallery-dots] button', root);
      if (!track_) return;
      track_.addEventListener('scroll', debounce(function () {
        var i = Math.round(track_.scrollLeft / track_.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, 60), { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track_.scrollTo({ left: k * track_.clientWidth, behavior: 'smooth' }); }); });
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lightbox-open]');
        if (b) Lightbox.open(root, +b.getAttribute('data-lightbox-open'));
      });
    },
    goToColor: function (root, color, mediaId) {
      var track_ = root.querySelector('[data-gallery-track]');
      if (!track_) return;
      var slides = $$('.gallery__slide', track_);
      var target = mediaId ? slides.filter(function (s) { return +s.getAttribute('data-media-id') === mediaId; })[0] : null;
      if (!target && color) {
        var c = color.toLowerCase().replace(/[^a-z]/g, '');
        target = slides.filter(function (s) { return (s.getAttribute('data-media-alt') || '').toLowerCase().replace(/[^a-z]/g, '').indexOf(c) > -1; })[0];
      }
      if (!target) return;
      if (matchMedia('(min-width: 990px)').matches) {
        // Desktop grid: move the matching image to the front
        track_.insertBefore(target, track_.firstChild);
      } else {
        track_.scrollTo({ left: target.offsetLeft - track_.offsetLeft, behavior: 'smooth' });
      }
    }
  };

  var Lightbox = {
    open: function (root, index) {
      var imgs = $$('.gallery__slide img', root).map(function (i) {
        var src = i.currentSrc || i.src; return src.replace(/([?&])width=\d+/, '$1width=2400');
      });
      if (!imgs.length) return;
      var lb = document.createElement('div');
      lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Image viewer'); lb.tabIndex = -1;
      lb.innerHTML = '<span class="lightbox__count" aria-live="polite"></span>' +
        '<button class="lightbox__close" type="button" aria-label="Close">✕</button>' +
        '<button class="lightbox__nav lightbox__nav--prev" type="button" aria-label="Previous image">‹</button>' +
        '<button class="lightbox__nav lightbox__nav--next" type="button" aria-label="Next image">›</button>' +
        '<div class="lightbox__track">' + imgs.map(function (s, k) { return '<div class="lightbox__slide"><img src="' + s + '" alt="Image ' + (k + 1) + ' of ' + imgs.length + '" loading="' + (k === index ? 'eager' : 'lazy') + '"></div>'; }).join('') + '</div>';
      document.body.appendChild(lb);
      var tr = lb.querySelector('.lightbox__track');
      var count = lb.querySelector('.lightbox__count');
      var cur = index;
      var go = function (i) { cur = Math.max(0, Math.min(imgs.length - 1, i)); tr.scrollTo({ left: cur * tr.clientWidth }); count.textContent = (cur + 1) + ' / ' + imgs.length; };
      requestAnimationFrame(function () { go(index); });
      tr.addEventListener('scroll', debounce(function () { cur = Math.round(tr.scrollLeft / tr.clientWidth); count.textContent = (cur + 1) + ' / ' + imgs.length; }, 80));
      tr.addEventListener('click', function (e) {
        var s = e.target.closest('.lightbox__slide'); if (!s) return;
        var img = s.querySelector('img');
        var zoomed = s.classList.toggle('is-zoomed');
        if (zoomed) {
          var r = img.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          requestAnimationFrame(function () { s.scrollLeft = px * s.scrollWidth - s.clientWidth / 2; s.scrollTop = py * s.scrollHeight - s.clientHeight / 2; });
        }
      });
      var close = function () { lb.remove(); document.removeEventListener('keydown', key); lock(false); };
      var key = function (e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); };
      lb.querySelector('.lightbox__close').addEventListener('click', close);
      lb.querySelector('.lightbox__nav--prev').addEventListener('click', function () { go(cur - 1); });
      lb.querySelector('.lightbox__nav--next').addEventListener('click', function () { go(cur + 1); });
      document.addEventListener('keydown', key);
      lock(true); lb.focus();
    }
  };

  /* ======================================================================
     QUICK VIEW
     ====================================================================== */
  var QuickView = {
    open: function (url, opener) {
      var modal = $('#QuickView'); var body = $('[data-quickview-body]', modal);
      body.innerHTML = '<p class="muted" style="padding:40px;text-align:center">Loading…</p>';
      openLayer(modal, opener);
      fetch(url.split('?')[0] + '?section_id=quick-view').then(function (r) { return r.text(); }).then(function (html) {
        var doc = parseHTML(html);
        var root = doc.querySelector('[data-product-root]');
        body.innerHTML = root ? root.outerHTML : html;
        initProduct($('[data-product-root]', body));
        Wishlist.paint();
        track('view_item', { source: 'quick_view', url: url });
      });
    }
  };

  /* ======================================================================
     WISHLIST (guest, localStorage) + share + send to stylist
     ====================================================================== */
  var WKEY = 'pd_wishlist';
  var Wishlist = PD.wishlist = {
    list: function () { return store.get(WKEY, []); },
    save: function (l) { store.set(WKEY, l); Wishlist.paint(); document.dispatchEvent(new CustomEvent('pd:wishlist', { detail: l })); },
    toggle: function (handle) {
      var l = Wishlist.list(); var i = l.indexOf(handle);
      if (i > -1) { l.splice(i, 1); toast('Removed from wishlist'); }
      else { l.unshift(handle); toast('Saved to your wishlist ♡'); track('add_to_wishlist', { item_id: handle }); }
      Wishlist.save(l.slice(0, 100));
      if ($('[data-wish-grid]') && i > -1 && !Wishlist.shared) Wishlist.renderPage();
    },
    paint: function () {
      var l = Wishlist.list();
      $$('[data-wish]').forEach(function (b) { var on = l.indexOf(b.getAttribute('data-wish')) > -1; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
      $$('[data-wish-count]').forEach(function (c) { c.textContent = l.length || ''; c.setAttribute('data-count', l.length); });
    },
    renderPage: function () {
      var grid = $('[data-wish-grid]'); if (!grid) return;
      var params = new URLSearchParams(location.search);
      var shared = params.get('items');
      Wishlist.shared = !!shared;
      var handles = shared ? shared.split(',').filter(Boolean).slice(0, 60) : Wishlist.list();
      $('[data-wish-shared-note]').hidden = !shared;
      $('[data-wish-empty]').hidden = handles.length > 0;
      $('[data-wish-actions]').hidden = handles.length === 0;
      renderCards(grid, handles);
    }
  };
  function renderCards(grid, handles) {
    grid.innerHTML = '';
    return Promise.all(handles.map(function (h) {
      return fetch(PD.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=product-card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      htmls.forEach(function (html) { if (!html) return; var c = parseHTML(html).querySelector('.card'); if (c) grid.appendChild(c); });
      reveal(grid); Wishlist.paint();
      return grid.children.length;
    });
  }
  Wishlist.paint();
  Wishlist.renderPage();
  var shareBtn = $('[data-wish-share]');
  if (shareBtn) shareBtn.addEventListener('click', function () {
    var url = location.origin + location.pathname + '?items=' + Wishlist.list().join(',');
    if (navigator.share) navigator.share({ title: 'My DOLLZ wishlist', url: url }).catch(function () {});
    else copy(url);
    track('share', { content_type: 'wishlist' });
  });
  var wStylist = $('[data-wish-stylist]');
  if (wStylist) wStylist.addEventListener('click', function () {
    var styles = $$('[data-wish-grid] .card').map(function (c) { return (c.querySelector('.card__designer') || {}).textContent + ' ' + (c.querySelector('.card__title') || {}).textContent; });
    wStylist.setAttribute('data-style', styles.join('; ').replace(/\s+/g, ' ').trim());
    wStylist.setAttribute('data-url', location.origin + location.pathname + '?items=' + Wishlist.list().join(','));
    Stylist.open(wStylist);
  });
  var wAppt = $('[data-wish-appt]');
  if (wAppt) wAppt.href = wAppt.getAttribute('href') + '?style=' + encodeURIComponent(Wishlist.list().join(', '));

  /* ======================================================================
     RECENTLY VIEWED
     ====================================================================== */
  var RKEY = 'pd_recent';
  var Recent = {
    push: function (h) { var l = store.get(RKEY, []).filter(function (x) { return x !== h; }); l.unshift(h); store.set(RKEY, l.slice(0, 12)); },
    render: function () {
      var sec = $('[data-recently-viewed]'); if (!sec) return;
      var cur = ($('[data-product-root]') || {}).getAttribute ? $('[data-product-root]').getAttribute('data-product-handle') : '';
      var l = store.get(RKEY, []).filter(function (x) { return x !== cur; }).slice(0, 8);
      if (!l.length) return;
      renderCards($('[data-recent-grid]', sec), l).then(function (n) { sec.hidden = !n; });
    },
    chips: function () {
      var box = $('[data-recent-chips]'); if (!box) return;
      var l = store.get(RKEY, []).slice(0, 6);
      if (!l.length) return;
      box.innerHTML = l.map(function (h) { return '<a class="chip" href="/products/' + encodeURIComponent(h) + '">' + h.replace(/-/g, ' ').toUpperCase() + '</a>'; }).join('');
    }
  };

  /* ---------------- Async recommendations ---------------- */
  var rec = $('[data-recommendations]');
  if (rec) {
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = parseHTML(html).querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { rec.innerHTML = fresh.innerHTML; reveal(rec); Wishlist.paint(); }
    }).finally(Recent.render);
  } else { Recent.render(); }

  /* ======================================================================
     SEARCH — overlay, predictive, smart query parsing
     ====================================================================== */
  var Search = {
    open: function (opener) {
      var ov = $('#SearchOverlay'); openLayer(ov, opener); Recent.chips();
      setTimeout(function () { var i = $('#SearchInput'); if (i) i.focus(); }, 80);
    }
  };
  var pInput = $('[data-predictive-input]');
  if (pInput) {
    var results = $('[data-predictive-results]'), defaults = $('[data-search-default]');
    pInput.addEventListener('input', debounce(function () {
      var q = pInput.value.trim();
      if (q.length < 2) { results.innerHTML = ''; defaults.hidden = false; return; }
      var clean = SmartSearch.parse(q).q || q;
      fetch(PD.routes.predictiveSearch + '?q=' + encodeURIComponent(clean) + '&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag,body')
        .then(function (r) { return r.text(); }).then(function (html) {
          var body = parseHTML(html).querySelector('.search-ov__grid');
          results.innerHTML = body ? body.outerHTML : '';
          defaults.hidden = !!body; reveal(results); Wishlist.paint();
        });
    }, 220));
  }

  var SmartSearch = PD.smartSearch = {
    STYLE_RE: /^[a-z]{0,5}\d{3,6}[a-z]{0,2}$/i,
    parse: function (raw) {
      var q = ' ' + raw.trim() + ' ', filters = [];
      var m;
      // "size 16", "sz 18w", "size xs"
      q = q.replace(/\b(?:size|sz)\s*([0-9]{1,3}w?|xxs|xs|s|m|l|xl|2xl|3xl)\b/ig, function (_, s) { filters.push(['filter.v.option.size', s.toUpperCase()]); return ' '; });
      // "under $500", "below 400"
      q = q.replace(/\b(?:under|below|less than)\s*\$?\s*([0-9]{2,5})\b/ig, function (_, n) { filters.push(['filter.v.price.lte', n]); return ' '; });
      q = q.replace(/\b(?:over|above)\s*\$?\s*([0-9]{2,5})\b/ig, function (_, n) { filters.push(['filter.v.price.gte', n]); return ' '; });
      // "in stock"
      q = q.replace(/\bin[\s-]?stock\b/ig, function () { filters.push(['filter.v.availability', '1']); return ' '; });
      q = q.replace(/\s+/g, ' ').trim();
      return { q: q, filters: filters };
    },
    go: function (raw) {
      var p = SmartSearch.parse(raw);
      track('search', { search_term: raw });
      var build = function (base) {
        var u = new URL(base, location.origin);
        if (p.q) { u.searchParams.set('q', p.q); u.searchParams.set('type', 'product'); u.searchParams.set('options[prefix]', 'last'); }
        p.filters.forEach(function (f) { u.searchParams.append(f[0], f[1]); });
        return u.toString();
      };
      // Exact style number → jump straight to the product
      if (SmartSearch.STYLE_RE.test(p.q) && !p.filters.length) {
        return fetch(PD.routes.predictiveSearch + '.json?q=' + encodeURIComponent(p.q) + '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,variants.sku,tag')
          .then(function (r) { return r.json(); }).then(function (d) {
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            var re = new RegExp('(^|\\s)' + p.q + '(\\s|$)', 'i');
            var hit = prods.filter(function (x) { return re.test(x.title); })[0];
            location.href = hit ? hit.url : build(PD.routes.search);
          }).catch(function () { location.href = build(PD.routes.search); });
      }
      location.href = build(p.q ? PD.routes.search : '/collections/all');
    }
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-smart-search]')) {
      var i = f.querySelector('[name="q"]'); if (!i || !i.value.trim()) { e.preventDefault(); return; }
      e.preventDefault(); SmartSearch.go(i.value);
    }
  });

  /* ======================================================================
     FACETS — AJAX filtering via the Section Rendering API
     ====================================================================== */
  var sectionRoot = $('[data-section-root]');
  var Facets = {
    sectionId: sectionRoot && sectionRoot.getAttribute('data-section-root'),
    urlFromForm: function (form) {
      var fd = new FormData(form); var params = new URLSearchParams();
      var preset = fd.get('_price_preset');
      fd.forEach(function (v, k) { if (k !== '_price_preset' && v !== '') params.append(k, v); });
      if (preset && Facets._presetChanged) {
        var parts = preset.split('-');
        $$('[data-price-min]', form).forEach(function (x) { params.delete(x.name); if (+parts[0] > 0) params.set(x.name, parts[0]); });
        $$('[data-price-max]', form).forEach(function (x) { params.delete(x.name); if (parts[1]) params.set(x.name, parts[1]); });
      }
      Facets._presetChanged = false;
      return form.getAttribute('action').split('?')[0] + '?' + params.toString();
    },
    load: function (url, push) {
      var results = $('[data-results]'); if (results) results.classList.add('is-loading');
      var drawerOpen = $('#FacetsDrawer') && $('#FacetsDrawer').classList.contains('is-open');
      var u = new URL(url, location.origin); u.searchParams.set('section_id', Facets.sectionId);
      fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var doc = parseHTML(html);
        var fresh = doc.querySelector('[data-results-root]');
        var cur = $('[data-results-root]');
        if (fresh && cur) {
          // Keep open/closed state of facet groups
          var openState = {}; $$('.facet', cur).forEach(function (d, i) { openState[(d.querySelector('summary') || {}).textContent] = d.open; });
          var scroller = $('.facets-wrap__body', cur); var st = scroller ? scroller.scrollTop : 0;
          cur.innerHTML = fresh.innerHTML;
          $$('.facet', cur).forEach(function (d) { var k = (d.querySelector('summary') || {}).textContent; if (k in openState) d.open = openState[k]; });
          var sc2 = $('.facets-wrap__body', cur); if (sc2) sc2.scrollTop = st;
          if (drawerOpen) { var dr = $('#FacetsDrawer'); dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); openLayers = openLayers.filter(function (x) { return document.body.contains(x); }); openLayers.push(dr); }
          reveal(cur); Wishlist.paint();
        }
        var clean = new URL(url, location.origin); clean.searchParams.delete('section_id');
        if (push !== false) history.pushState({ facets: true }, '', clean);
        var active = []; clean.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0) active.push(k.replace('filter.', '') + '=' + v); });
        track('filter_products', { filters: active.join('|'), sort: clean.searchParams.get('sort_by') || '' });
        if (!drawerOpen) { var top = $('[data-results]'); if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth' }); }
      }).catch(function () { location.href = url; });
    }
  };
  if (Facets.sectionId) {
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-facets-form]');
      if (form) {
        if (e.target.hasAttribute('data-price-preset')) Facets._presetChanged = true;
        if (e.target.hasAttribute('data-price-min') || e.target.hasAttribute('data-price-max')) $$('[data-price-preset]', form).forEach(function (r) { r.checked = false; });
        Facets.load(Facets.urlFromForm(form)); return;
      }
      if (e.target.matches('[data-sort-select]')) {
        var f = $('[data-facets-form]');
        var mirror = f && f.querySelector('[data-sort-mirror]');
        if (mirror) { mirror.value = e.target.value; Facets.load(Facets.urlFromForm(f)); }
        else { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); Facets.load(u.toString()); }
      }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-facet-link]');
      if (a) { e.preventDefault(); Facets.load(a.href); }
    });
    window.addEventListener('popstate', function () { Facets.load(location.href, false); });
  }

  /* ======================================================================
     NEWSLETTER POPUP — exit intent (desktop), delay, scroll depth; frequency capped
     ====================================================================== */
  var PKEY = 'pd_popup_until';
  var Popup = {
    el: $('#NewsletterPopup'),
    shown: false,
    blocked: function () { return Date.now() < (store.get(PKEY, 0) || 0); },
    show: function (reason) {
      if (Popup.shown || !Popup.el || Popup.blocked() || openLayers.length) return;
      Popup.shown = true; openLayer(Popup.el);
      track('popup_view', { trigger: reason });
    },
    dismiss: function () {
      var days = +(Popup.el && Popup.el.getAttribute('data-days')) || 14;
      store.set(PKEY, Date.now() + days * 864e5);
    },
    init: function () {
      if (!Popup.el) return;
      if (Popup.el.querySelector('[data-popup-success]')) {
        store.set(PKEY, Date.now() + 365 * 864e5);
        openLayer(Popup.el); track('generate_lead', { method: 'newsletter', coupon: '10%' });
        return;
      }
      if (Popup.blocked()) return;
      var delay = (+Popup.el.getAttribute('data-delay') || 12) * 1000;
      var scrollPct = (+Popup.el.getAttribute('data-scroll') || 45) / 100;
      var armed = false; setTimeout(function () { armed = true; }, 3000);
      setTimeout(function () { Popup.show('delay'); }, delay);
      window.addEventListener('scroll', debounce(function () {
        var h = document.documentElement.scrollHeight - innerHeight;
        if (armed && h > 0 && scrollY / h > scrollPct) Popup.show('scroll');
      }, 150), { passive: true });
      if (matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseout', function (e) { if (armed && !e.relatedTarget && e.clientY <= 0) Popup.show('exit_intent'); });
      }
    }
  };
  Popup.init();

  /* ======================================================================
     STYLIST MODAL + SIZE GUIDE MODAL
     ====================================================================== */
  var Stylist = {
    open: function (btn) {
      var m = $('#StylistModal'); if (!m) return;
      var set = function (sel, v) { var x = $(sel, m); if (x) x.value = v || ''; };
      set('[data-stylist-style]', btn.getAttribute('data-style'));
      set('[data-stylist-link]', btn.getAttribute('data-url'));
      set('[data-stylist-size]', btn.getAttribute('data-size'));
      set('[data-stylist-color]', btn.getAttribute('data-color'));
      var qv = $('#QuickView'); if (qv && !qv.hidden) closeLayer(qv);
      openLayer(m, btn);
    }
  };
  var SizeGuide = {
    open: function (url, opener) {
      var m = $('#QuickView'); var body = $('[data-quickview-body]', m);
      body.innerHTML = '<p class="muted" style="padding:40px;text-align:center">Loading size guide…</p>';
      openLayer(m, opener);
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var main = parseHTML(html).querySelector('#MainContent');
        body.innerHTML = main ? main.innerHTML : '<p>Size guide unavailable.</p>';
        $$('.breadcrumbs', body).forEach(function (b) { b.remove(); });
      }).catch(function () { location.href = url; });
    }
  };

  /* ======================================================================
     FORMS — success states, appointment helpers, analytics
     ====================================================================== */
  (function formSuccess() {
    var q = location.search;
    if (q.indexOf('contact_posted=true') === -1) return;
    var id = (location.hash || '').replace('#', '');
    var form = id ? document.getElementById(id) : null;
    if (!form) {
      try { form = document.getElementById(sessionStorage.getItem('pd_form') || ''); } catch (e) {}
    }
    if (!form) return;
    var ok = form.querySelector('[data-form-success]'), fields = form.querySelector('[data-form-fields]');
    if (ok) ok.hidden = false; if (fields) fields.hidden = true;
    var modal = form.closest('.modal'); if (modal) openLayer(modal);
    else form.scrollIntoView({ block: 'center' });
    if (id === 'AppointmentForm') track('appointment_request', { method: 'request_form' });
    else if (id === 'StylistForm') track('generate_lead', { method: 'stylist_request' });
    else track('contact', { method: 'contact_form' });
    history.replaceState(null, '', location.pathname);
  })();

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.id) return;
    try { sessionStorage.setItem('pd_form', f.id); } catch (err) {}
    if (f.id === 'AppointmentForm') {
      var first = $('#ApptFirst', f), last = $('#ApptLast', f), full = $('[data-appt-fullname]', f);
      if (full) full.value = ((first && first.value) + ' ' + (last && last.value)).trim();
      var dp = $('[data-designer-field]', f);
      if (dp) dp.value = $$('[data-designer-pref]:checked', f).map(function (c) { return c.value; }).join(', ');
    }
  }, true);

  // Appointment page helpers
  var apptForm = $('#AppointmentForm');
  if (apptForm) {
    var params = new URLSearchParams(location.search);
    var s = params.get('style'); var sf = $('[data-appt-style]', apptForm); if (s && sf) sf.value = s;
    var today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    $$('[data-min-today]', apptForm).forEach(function (d) { d.min = today.toISOString().slice(0, 10); });
    var typeParam = (params.get('type') || '').toLowerCase();
    if (typeParam) $$('input[name="contact[Appointment type]"]', apptForm).forEach(function (r) { if (r.value.toLowerCase().indexOf(typeParam) > -1) r.checked = true; });
    // Inspiration upload integration point
    var inspo = $('[data-inspo-input]', apptForm);
    if (inspo) inspo.addEventListener('change', function () {
      var files = Array.prototype.slice.call(inspo.files, 0, 5); if (!files.length) return;
      var fd = new FormData(); files.forEach(function (fl) { fd.append('files', fl); });
      var out = $('[data-inspo-field]', apptForm); out.value = 'Uploading…';
      fetch(inspo.getAttribute('data-endpoint'), { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { out.value = (d.urls || d.files || []).join(' , ') || files.map(function (x) { return x.name; }).join(', '); toast('Photos attached'); })
        .catch(function () { out.value = files.map(function (x) { return x.name; }).join(', ') + ' (upload failed)'; toast('Upload failed — you can email photos instead'); });
    });
  }
  // Tabs
  $$('[role=tablist]').forEach(function (list) {
    var tabs = $$('[data-tab]', list);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
        if (t.id === 'TabLive') track('appointment_cta', { location: 'live_tab' });
      });
    });
  });

  // Track button-style CTAs on click (buttons skip the global anchor tracker to avoid double counting)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-track]');
    if (b && b.type !== 'submit') track(b.getAttribute('data-track'), { location: b.getAttribute('data-track-location') || '' });
  });

  // Initialise product pages last, once every module above exists
  $$('[data-product-root]').forEach(initProduct);

  // Search page: log the search that produced this page
  if (document.body.classList.contains('template-search')) {
    var term = new URLSearchParams(location.search).get('q');
    if (term) track('search', { search_term: term, results: ($('[data-results-count]') || {}).textContent || '' });
  }
})();
